module.exports = __webpack_public_path__ + "static/media/5.49772420.png";